<template>
  <div>
    <PageTitle :route="$route"> </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <InfractionTypeForm
          v-if="infractiontype"
          :infractionType="infractiontype"
        />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import PageTitle from "@/components/layout/PageTitle";
import PageRowWrapper from "@/components/layout/PageRowWrapper";
import InfractionTypeForm from "@/components/settings/frota/infractions-types/InfractionTypeForm.vue";

export default {
  name: "InfractionTypeEdit",

  components: {
    PageTitle,
    PageRowWrapper,
    InfractionTypeForm,
  },

  computed: {
    ...mapState({
      infractiontype: (state) => state.infractiontype.infractionTypeById,
    }),
  },

  methods: {
    ...mapActions("infractiontype", ["fetchById"]),
  },

  mounted() {
    this.fetchById(this.$route.params.id);
  },
};
</script>
